const posEn = {
	pos: {
		common: {
			cancel: "Cancel",
			save: "Save",
			notification: "Notifications",
			decrease: "Decrease",
			increase: "Increase",
			backspace: "Backspace",
		},
		nav: {
			catalog: "Catalog",
			order: "Orders/Held",
			history: "History",
			settlement: "Settlement",
			expenses: "Expenses",
			more: "More",
			dashboard: "Dashboard",
			menu: "Menu",
		},
		catalog: {
			search: "Search products...",
			manualOrder: "Manual Order",
			listView: "List view",
			gridView: "Grid view",
			allProducts: "All Products",
			notFound: "No products found.",
			loading: "Loading products...",
			loadFailed: "Failed to load products.",
			retry: "Try again",
			variant: "{count} Variant",
			outOfStock: "Out of stock",
			stockLimit: "Only {stock} left for '{name}'",
		},
		variant: {
			subtitle: "{count} product variants",
			save: "Save",
		},
		panel: {
			title: "Order Details",
			add: "Add",
			addNote: "+ Note",
			addDiscount: "+ Discount",
			addOrderDiscount: "+ Add Discount",
			discountTitle: "Add Discount",
			discountItemTitle: "Discount · {name}",
			discountBase: "Base: {amount}",
			discountTypePercent: "Percent (%)",
			discountTypeFixed: "Fixed (Rp)",
			removeDiscount: "Remove Discount",
			addCategoryDiscount: "+ Category Discount",
			removeCategoryDiscount: "Remove Category Discount",
			categoryDiscount: "Category Discount",
			promoDiscount: "Promo Discount",
			itemNotePlaceholder: "Item note",
			discountPlaceholder: "Discount (Rp)",
			discountLabel: "Discount",
			subtotal: "Subtotal",
			orderDetails: "Order Details",
			addDiscountButton: "Add discount",
			transactionNotePlaceholder: "Write a note for this transaction",
			tax: "Tax & Surcharge {percent}%",
			rounding: "Rounding",
			total: "Total",
			transactionNote: "Transaction note (optional)",
			paymentMethod: "Payment Method",
			choosePayment: "Choose method",
			changePayment: "Change",
			emptyTitle: "No items yet",
			emptyDesc: "Pick a product on the left to start an order.",
			deleteOrder: "Delete Order",
			payNow: "Pay Now",
			saveOrder: "Save order",
			itemCount: "{count} item(s)",
			wholesale: "Wholesale",
			noteChip: "Note",
			discountChip: "Discount",
		},
		payment: {
			title: "Payment",
			methodTitle: "Choose Payment Method",
			totalBill: "Total bill {amount}",
			methodSubtitle: "{method} · Total {amount}",
			groupCash: "Cash",
			groupCashless: "Cashless",
			choose: "Choose",
			customer: "Customer",
			addCustomer: "Add Customer",
			points: "{count} Points",
			cashReceived: "Cash Received",
			exactAmount: "Exact Amount",
			payCash: "Pay Cash · {amount}",
			pay: "Pay",
			cardNumber: "Card Number",
			cardNumberPlaceholder: "Enter the 16-digit card number",
			scan: "Scan",
			scanTitle: "Scan Card",
			scanSubtitle: "Scan the card's QR / barcode",
			scanHint:
				"Position the card's QR / barcode inside the frame. Scanning runs automatically once the card is detected.",
			scannerActive: "Barcode Scanner Active",
			rfidActive: "RFID Reader Active",
			manualInput: "Enter card number manually",
			cancel: "Cancel",
			pinTitle: "Enter Card PIN",
			forgotPin: "Forgot PIN?",
			wrongPin: "Wrong PIN. Try again.",
			processing: "Processing...",
			loading: "Loading...",
			payAmount: "Pay · {amount}",
			customerTitle: "Choose Customer",
			customerSubtitle: "{count} saved customers",
			customerSearch: "Search by name or phone…",
			customerCard: "CARD · {number}",
			customerEmpty: "No customer found.",
			customerNew: "Add New Customer",
			customerNewSubtitle: "The new customer is selected right after saving",
			customerName: "Customer Name",
			customerNamePlaceholder: "e.g. Mrs. Sari",
			customerPhone: "Phone Number",
			customerEmail: "Email (optional)",
			customerAdded: "Customer {name} added",
			customerRequired: "Customer (required)",
			cardType: "Card Type",
			cardTypeDebit: "Debit",
			cardTypeCredit: "Credit",
			bank: "Issuing Bank",
			bankPlaceholder: "Choose a bank...",
			cardLast4: "Card Number",
			cardLast4Placeholder: "Enter the last 4 digits of the card",
			cardLast4Hint: "Digits only, for record keeping",
			cardHolder: "Name on Card",
			cardHolderPlaceholder: "Name as printed on the card",
			debitRecordOnly:
				"The fields below are for record keeping only, the system does not process the EDC transaction.",
			dueDate: "Due Date",
			dueDatePlaceholder: "Pick a due date",
			dueDateRequired: "Due date is required.",
			customerRequiredError: "A customer must be selected.",
			downPayment: "Down Payment",
			receivedOptional: "Amount Received (optional)",
			receivedPlaceholder: "Enter the amount received",
			receivedLabel: "Amount Received",
			dpNoChange: "A partial payment (DP) has no change",
			remaining: "Outstanding",
			noteTitle: "Note",
			hutangNote:
				"The debt is recorded as unpaid and appears in Debt History to settle later.",
			unpaidShort: "Unpaid",
			finishTransaction: "Complete Transaction",
			saveHutang: "Save Debt",
			preorderInfo:
				"The order is saved as a Pre Order (Pending) without charging payment. Settle it later from Pre Order History.",
			preorderNote: "Note (optional)",
			preorderNotePlaceholder: "e.g. pick up tomorrow at 10:00",
			statusLabel: "Status",
			pendingShort: "Pending",
			noteCounter: "{count}/{max}",
			savePreorder: "Save Pre Order",
			qrisTitle: "QRIS Payment",
			qrisGenerating: "Generating QR code...",
			qrisWaiting: "Awaiting Payment",
			qrisTotal: "Total Payment",
			qrisLocked: "Amount locked · Close Payment",
			qrisNmid: "NMID {nmid}",
			qrisHint:
				"Scan the QR code with any e-wallet or mobile banking app to complete the payment.",
			qrisCheckStatus: "Check Payment Status",
			qrisChecking: "Checking status...",
			qrisStillPending: "Payment not received yet. Try again.",
			recordOnly:
				"{method} is settled outside the system. The transaction is only recorded.",
			confirmPayment: "Confirm Payment",
			successTitle: "Payment Successful!",
			unpaidTitle: "Debt Recorded",
			pendingTitle: "Awaiting Payment",
			successDesc: "Transaction #{invoice} was paid via {method}",
			recordedDesc: "Transaction #{invoice} was recorded via {method}",
			pointsEarned: "+ {points} points earned by {name}",
			successBadge: "Success",
			unpaidBadge: "Debt",
			pendingBadge: "Pending",
			totalTransaction: "Transaction Total",
			cashTendered: "Cash Received",
			walletPayment: "{wallet} payment",
			change: "Change",
			sendReceipt: "Send Receipt",
			viewReceipt: "View Receipt",
			printReceipt: "Print Receipt",
			printerSettings: "Printer Setup",
			newOrder: "New Order",
			redeemTitle: "Redeem Points",
			redeemOption: "{points} pts · {reward}",
		},
		manual: {
			title: "Manual Order",
			subtitle: "Add a free-form item without a saved product",
			productName: "Product Name",
			productNamePlaceholder: "e.g. Custom birthday cake",
			price: "Price",
			qty: "Quantity",
			addToOrder: "Add to Order",
		},
		scan: {
			title: "Scan Product",
			subtitle: "Scan a product barcode / QR to add it to the order",
			hint: "Point the camera at the product barcode. USB/Bluetooth scanners also work on this page.",
			added: "{name} added",
			notFound: "No product found for code {code}",
			cameraStarting: "Starting camera...",
			cameraUnavailable:
				"Camera / detector unavailable in this browser. Use a USB scanner or manual input.",
		},
		receipt: {
			title: "Receipt",
			thanks: "Thank you!",
			send: "Send",
			sent: "Receipt sent via email",
			sendSubtitle: "The receipt is sent as a PDF attachment to this email.",
			customerEmail: "Customer email",
			cashier: "Cashier {name}",
			print: "Print Receipt",
			printing: "Printing receipt...",
		},
		held: {
			title: "Save Order",
			subtitle: "Park the cart to resume it later",
			namePlaceholder: "Order name (e.g. Table 4 / Mrs. Sari)",
			saved: "Order {name} saved",
			badge: "Saved",
			resume: "Resume",
			pay: "Pay",
			pending: "Pending",
			emptyTitle: "No orders yet",
			emptyDesc: "Orders saved from the Catalog page will show up here.",
			cartNotEmpty: "The cart still has items. Finish or clear it first.",
		},
		printer: {
			title: "Printer Setup",
			paperSize: "Paper Size",
			hint: "Make sure the printer is on and connected to the cashier device.",
		},
		split: {
			pageTitle: "Split Bill '{name}'",
			remaining: "{qty} {unit} left",
			backToOrder: "Back to Order",
			subtotal: "Subtotal",
			title: "Split Bill",
			subtitle: "Pick how many of each item to pay now",
			namePlaceholder: "Remainder order name (e.g. Table 4 - rest)",
			payNow: "Pay Now",
			confirm: "Pay & Save Remainder",
			done: "Remaining order saved as {name}",
			badge: "Split Bill",
		},
		history: {
			tabOrder: "Order",
			tabPreorder: "Pre Order",
			tabDebt: "Debt",
			tabExpenses: "Expenses",
			searchPlaceholder: "Search Ref ID / product name…",
			startDate: "Start date",
			endDate: "End date",
			allPayments: "All Methods",
			empty: "No transactions in this period.",
			loadMore: "Load more",
			manageExpenses: "Manage Expenses",
			unpaidAmount: "{amount} unpaid",
			noteLabel: "Notes",
			statusSuccess: "Success",
			statusSettled: "Settled",
			statusNotSettled: "Not Settled",
			statusPending: "Pending",
			statusCanceled: "Canceled",
			statusFailed: "Failed",
			copied: "Ref ID copied",
			detailSubtitle: "Transaction Detail",
			dateLabel: "Date & Time",
			systemDiscount: "Promo Discount",
			taxLabel: "Tax",
			itemsTitle: "Order Items",
			paymentsTitle: "Payment History",
			cancelAction: "Cancel Transaction",
			cancelTitle: "Cancel Transaction",
			cancelSubtitle: "Enter the cancellation reason and cashier PIN",
			cancelReasonPlaceholder: "Reason for cancellation",
			cancelPinPlaceholder: "Cashier PIN",
			cancelConfirm: "Cancel Transaction",
			cancelDone: "Transaction canceled",
			cancelReasonLabel: "Cancellation Reason",
			payDebtAction: "Pay Debt",
			payDebtTitle: "Pay Debt",
			payDebtSubtitle: "Remaining debt {amount}",
			payDebtTooMuch: "Amount exceeds the remaining debt.",
			payDebtConfirm: "Pay · {amount}",
			payDebtDone: "Debt payment recorded",
			payPreorderAction: "Pay Pre Order",
		},
		settlement: {
			tabRecap: "Recap",
			tabHistory: "Recap History",
			sale: "Sale",
			totalSale: "Total sale",
			qtySale: "Sale count",
			qtySaleValue: "{qty} Sales",
			cashTransaction: "Cash Transactions",
			initialCash: "Initial cash",
			cashPayment: "Cash payment",
			topupPpob: "Payment (Top Up & PPOB)",
			paymentDebt: "Debt payment",
			expenses: "Expenses",
			withdrawCardExpenses: "Card balance withdrawal",
			canceledTransaction: "Canceled transactions",
			total: "Total",
			nonCashTransaction: "Non-Cash Transactions",
			entryDischarge: "Entry discharge",
			eWallet: "E-Wallet",
			transferBank: "Bank transfer",
			entryBalance: "Entry balance",
			outBalance: "Out balance (Top Up, PPOB & Card Refund)",
			debt: "Debt",
			debtGiven: "Debt given",
			otherCosts: "Other Costs",
			discount: "Discount",
			fee: "Fee",
			tax: "Tax",
			setInitialCash: "Set Initial Cash",
			amountCash: "Cash Amount",
			set: "Save",
			setCashDone: "Initial cash saved",
			startRecap: "Start Recap",
			recapTitle: "Cash Recap",
			recapSubtitle: "Count the drawer cash, then process the recap",
			nonCashAmount: "Non-cash total",
			notes: "Notes",
			process: "Process Recap",
			recapDone: "Recap processed",
			empty: "No recap data yet.",
			from: "From",
			to: "To",
			cashSystem: "Cash according to system",
			settlementCash: "Cash at recap",
			difference: "Difference",
			cashierLabel: "Cashier",
			detailTitle: "Recap Detail",
		},
		expenses: {
			viewHistory: "View History",
			category: "Category",
			defaultCategory: "General",
			manageCategories: "Manage Categories",
			name: "Expense Name",
			namePlaceholder: "e.g. Water gallon refill",
			amount: "Amount",
			date: "Date",
			notes: "Notes (Optional)",
			notesPlaceholder: "Additional notes",
			save: "Save Expense",
			saved: "Expense saved",
			categoriesTitle: "Expense Categories",
			categoriesSubtitle: "Add or remove categories",
			noCategories: "No custom categories yet.",
			newCategoryPlaceholder: "New category name",
			addCategory: "Add",
			categoryAdded: "Category {name} added",
			categoryDeleted: "Category {name} deleted",
			deleteCategory: "Delete category",
		},
		more: {
			dashboard: "Dashboard",
			products: "Products",
			paperHint: "Receipt paper width for printing",
			paperOption: "{size} mm",
			cardSystem: "Cazh Cards",
			cardCheck: "Check Card",
			cardActivate: "Activate Card",
			cardTopUp: "Top Up Card",
			cardWithdraw: "Withdraw",
			billing: "Billing",
			pulsa: "Pulsa",
			cellularData: "Cellular Data",
			pln: "PLN",
			pdam: "PDAM",
			comingSoon: "{name} is not available yet",
		},
		card: {
			checkTitle: "Check Card",
			searchCard: "Search card",
			searchPlaceholder: "Enter name or card number",
			orLabel: "or",
			scanQR: "Scan QR Code",
			scanHint: "Point the camera at the QR code on the card",
			nfcWaiting: "Waiting for a card on the reader",
			nfcTapNow: "Tap the card on the device",
			nfcUnavailable: "No NFC reader available on this device",
			nfcReaderOff: "Reader Inactive",
			transactionLimit: "Transaction Limit",
			transactionLimitLeft: "Transaction Limit Left",
			withdrawLimit: "Withdrawal Limit",
			withdrawLimitLeft: "Withdrawal Limit Left",
			perDay: "{amount} / day",
			walletsTitle: "Card Wallets",
			tapNFC: "Tap Card (NFC)",
			check: "Check Card",
			checking: "Checking...",
			back: "Back",
			balance: "Balance",
			cardBlocked: "Card blocked",
			cardInactive: "Card inactive",
			cardNonaktif: "Card inactive",
			cardActive: "Card already active.",
			cardNotFound: "Card not found. Check the card number.",
			cardDetected: "Card detected",
			cardNotRecognized: "Card not registered in system",
			detailTitle: "Card Detail",
			cardNumber: "Card Number",
			holderName: "Holder Name",
			phone: "Phone",
			email: "Email",
			activatedAt: "Activation Date",
			status: "Status",
			statusActive: "Active",
			statusInactive: "Inactive",
			statusBlocked: "Blocked",
			checkOtherCard: "Check Other Card",
			activateTitle: "Activate Card",
			fullName: "Full Name",
			fullNamePlaceholder: "Cardholder full name",
			phoneNumber: "Phone Number",
			phonePlaceholder: "e.g. 08123456789",
			emailPlaceholder: "e.g. email@domain.com",
			regionCode: "Region Code",
			activate: "Activate",
			activating: "Activating...",
			activateSuccess: "Card activated",
			activateFailed: "Failed to activate card",
			warningTitle: "Warning",
			activateWarning:
				"Make sure the data is correct. It cannot be changed after activation.",
			topUpTitle: "Top Up Card",
			selectWallet: "Select Wallet",
			amount: "Amount",
			amountPlaceholder: "Enter amount",
			cashierPin: "Cashier PIN",
			cashierPinPlaceholder: "Enter cashier PIN",
			notes: "Notes (Optional)",
			notesPlaceholder: "Additional notes",
			topUpFee: "Top Up Fee",
			topUp: "Top Up",
			toppingUp: "Topping up...",
			topUpSuccess: "Top up successful",
			topUpFailed: "Failed to top up",
			topUpResultTitle: "Top Up Successful",
			topUpResultSubtitle: "Save this receipt as proof of top up",
			close: "Close",
			withdrawTitle: "Withdraw",
			withdrawSubtitle: "Withdraw from card wallet",
			cardPin: "Card PIN",
			cardPinPlaceholder: "Enter card PIN",
			withdraw: "Withdraw",
			withdrawing: "Withdrawing...",
			withdrawSuccess: "Withdrawal successful",
			withdrawFailed: "Failed to withdraw",
		},
		placeholder: {
			desc: "This page is under development. See docs/prd/POS_TRANSACTION.md.",
		},
	},
};

export default posEn;
